"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEADS_DEFAULT_INTAKE = void 0;
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
exports.LEADS_DEFAULT_INTAKE = (0, form_1.form)({
    name: "LEADS_DEFAULT_INTAKE",
    title: "Immigration Profile",
    content: [
        question_groups_1.QuestionGroup["LEADS_DEFAULT_LEGAL_NAME"],
        question_groups_1.QuestionGroup["LEADS_DEFAULT_PERSONAL_INFORMATION"],
        question_groups_1.QuestionGroup["LEADS_CONTACT_INFORMATION"],
        question_groups_1.QuestionGroup["LEADS_IMMIGRATION_STATUS"],
        question_groups_1.QuestionGroup["LEADS_WORK_EXPERIENCE"],
        question_groups_1.QuestionGroup["LEADS_EDUCATION_HISTORY"],
        question_groups_1.QuestionGroup["LEADS_COMMENTS_NOTES"],
    ],
    id: 87,
});
